import { BatchScopePicker } from "./BatchScopePicker";
import { IssuesTab } from "./batch-detail/IssuesTab";

export function IssuesGlobalPage() {
  return (
    <BatchScopePicker title="Issues">{(batch) => <IssuesTab batch={batch} />}</BatchScopePicker>
  );
}
